import {
    MembershipRequestType,
    membershipRequestSchema,
} from '@/api/membershipRequest'
import { membershipRequestQueryOptions } from '@/api/membershipRequestQueryOptions'
import LoadProgress from '@/components/LoadProgress'
import EditDetailAccordion, {
    useEditDetail,
} from '@/components/detail/EditDetailForm'
import { yupResolver } from '@hookform/resolvers/yup'
import { Grid, TextField } from '@mui/material'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import i18next from 'i18next'
import { enqueueSnackbar } from 'notistack'

export const Route = createFileRoute(
    '/_auth/membershiprequest_/$uuid',
)({
    component: MemberjobComponent,
})

function MemberjobComponent() {
    const params = Route.useParams()
    const membershipRequestQuery = useSuspenseQuery(
        membershipRequestQueryOptions(params.uuid),
    )
    const membershipRequest = membershipRequestQuery.data

    const onSubmit = (data: MembershipRequestType) => {
        data
        console.log('onSubmit')
        // updateMemberJobMutation.mutate(data);
        enqueueSnackbar(
            i18next.t('action.changed', {
                entity: i18next.t('entity.membershipRequest'),
            }),
        )
    }

    const onCancel = () => {
        console.log('onCancel')
    }

    const editDetail = useEditDetail({
        onSubmit,
        onCancel,
        resolver: yupResolver<MembershipRequestType, any, any>(membershipRequestSchema),
        defaultValues: { ...membershipRequest },
        title: i18next.t('entity.membershipRequest'),
    })

    const writeable = membershipRequest.permissions
        ? membershipRequest.permissions.some((perm) => perm === 'write')
        : false

    if (membershipRequestQuery.isLoading || membershipRequestQuery.isFetching) {
        return <LoadProgress />
    }

    return (
        (<EditDetailAccordion {...editDetail}>
            <Grid container spacing={2}>
                <input type="hidden" {...editDetail.register('uuid')} />
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 4
                    }}>
                    <TextField
                        defaultValue={membershipRequest.member?.scoutId}
                        {...editDetail.register('member.scoutId')}
                        disabled={true}
                        label={i18next.t('property.member.scoutId')}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 8
                    }}>
                    <TextField
                        defaultValue={membershipRequest.replyMessage}
                        {...editDetail.register('replyMessage')}
                        disabled={!writeable}
                        label={i18next.t('property.membershipRequest.replyMessage')}
                    />
                </Grid>
            </Grid>
        </EditDetailAccordion>)
    );
}
